module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_3_4.0828b297.png";